import { createFileRoute } from "@tanstack/react-router";
import AccessGroupsSection from "@/features/settings/components/access-groups-section";
import { useIsOrgAdmin } from "@/stores";

function SettingsAccessGroupsRoute() {
  const canEdit = useIsOrgAdmin();
  return <AccessGroupsSection canEdit={canEdit} />;
}

export const Route = createFileRoute("/_admin/settings/access-groups")({
  component: SettingsAccessGroupsRoute,
});
